import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import sortBy from 'lodash/sortBy'
import { Skeleton, ProductItem } from '../components'
import { FormattedMessage } from 'react-intl'
import { makeSelectCurOrg } from 'logic/orgs'
import { fetchProducts, makeSelectLoading, makeSelectProducts } from 'logic/goods'
import messages from '../i18n/messages'

export default function GoodsListing () {

  const products = useSelector(makeSelectProducts())
  const org = useSelector(makeSelectCurOrg())
  const loading = useSelector(makeSelectLoading())
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchProducts(org.odn))
  }, [])

  return (
    <div className="card">
      <div className="m-4">
        <h2 className="text-center">
          <FormattedMessage {...messages.drinksListing} />
        </h2>
        <div className="text-muted text-center">
          <FormattedMessage {...messages.drinksListingDesc} />
        </div>
      </div>
      {loading && !products
        ? <div className="p-2 mb-4">
            <Skeleton className="mb-2" duration={0.8} height="2em" />
            <Skeleton className="mb-2" duration={2} height="2em" />
            <Skeleton className="mb-2" height="2em" />
          </div>
        : null
      }
      <div className="mt-4">
        {products && sortBy(products, 'position').map(product => (
          <ProductItem product={product} key={`prod-${product.id}`} />
          ))
        }
      </div>
    </div>
  )
}
